// function Question({text}){
//     const lines = []
//     for (let i=0 ; i<text.length ; i +=50)
//     {
//         lines.push(text.substring(i, i+50))
//     }



//     return (
//         <div>
//             {lines.map((line, idx) => (
//                 <p key = {idx} style={{margin:0}}>
//                     {line}
//                 </p>
//             ))}
//         </div>
//     )
// }
// export default Question;




function Question({text, maxLineLength = 40}){
    const words = text.split(" ")
    const lines = []
    let currentLine = ""

    for(const word of words){
        if((currentLine + (currentLine ? " " : "")+word).length > maxLineLength){
            if (currentLine) lines.push(currentLine);
            currentLine = word
        }
        else{
            currentLine += (currentLine ? " " : "") + word;
        }
    }
    if (currentLine) lines.push(currentLine)

        return (
            <div>
                {lines.map((line, idx) => (
                    <p key={idx} style={{margin :0}}>
                        {line}
                    </p>
                ))}
            </div>
        )
}

export default Question;